import React from 'react';
import SemiNarrowContainer from './SemiNarrowContainer';
import Button from './Buttons';
import retirementPlanningAppImg from "../images/guides/retirement-planning-app.webp";

const GuideAppCta = ({ 
    title = "Planning for retirement is easier with the Holborn app",
    content = "Track your investments, monitor your retirement goals, and manage your financial documents securely, all in one place. Get real-time insights, easy access to your portfolio, and tools that keep your retirement plan on track, wherever you are.",
    buttonText = "Learn more",
    buttonLink = "/holborn-app/",
    guideImage = retirementPlanningAppImg,
    imageAlt = "Holborn App Interface showing retirement planning features"
}) => {
    return (
        <div 
            className="w-full"
            style={{ 
                background: 'linear-gradient(to right, white 0%, #f7f8f8 25%, #f7f8f8 75%, white 100%)' 
            }}
        >
            <SemiNarrowContainer className="pt-12 lg:pt-16 pb-12 xl:pb-0">
                <div className="grid grid-cols-1 gap-12 xl:grid-cols-2 xl:gap-16 items-start">
                    <div className="flex flex-col justify-start pt-6">
                        <h2 className="text-3xl font-bold mb-4">
                            {title}
                        </h2>
                        <div className="space-y-4 text-lg text-gray-700 mb-8">
                            {content.split('. ').map((sentence, index, array) => (
                                <p key={index} className="leading-relaxed">
                                    {sentence}{index < array.length - 1 ? '.' : ''}
                                </p>
                            ))}
                        </div>
                        <div className="mt-auto"> 
                            <Button variant="blue" to={buttonLink}>
                                {buttonText}
                            </Button>
                        </div>
                    </div>
                    <div className="relative overflow-hidden hidden xl:block xl:h-96">
                        <img
                            src={guideImage}
                            alt={imageAlt}
                            className="w-full h-[200%] object-contain object-top"
                        />
                    </div>
                </div>
            </SemiNarrowContainer>
        </div>
    );
};

export default GuideAppCta;